import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './InputForm.css';

const MONTHS = ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'];
const WEEKDAYS = ['日','一','二','三','四','五','六'];

function getDaysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

function buildCalendar(year, month) {
  // month: 1-12
  const firstDay = new Date(year, month - 1, 1).getDay();
  const days = getDaysInMonth(year, month);
  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= days; d++) cells.push(d);
  return cells;
}

export default function InputForm({ setResult, setLoading }) {
  const today = new Date();
  const [showShanren, setShowShanren] = useState(false);
  const [calYear, setCalYear] = useState(today.getFullYear());
  const [calMonth, setCalMonth] = useState(today.getMonth() + 1);
  const [selYear, setSelYear] = useState(today.getFullYear());
  const [selMonth, setSelMonth] = useState(today.getMonth() + 1);
  const [selDay, setSelDay] = useState(today.getDate());
  const [hour, setHour] = useState(8);
  const [minute, setMinute] = useState(0);
  const [gender, setGender] = useState('男');
  const [name, setName] = useState('某君');
  const [useSolarTime, setUseSolarTime] = useState(false);
  const [provinces, setProvinces] = useState({});
  const [province, setProvince] = useState('');
  const [city, setCity] = useState('');
  const [lunarInfo, setLunarInfo] = useState(null);

  // 加载省市数据
  useEffect(() => {
    axios.get('/api/regions').then(res => {
      setProvinces(res.data.data);
      const firstProv = Object.keys(res.data.data)[0];
      setProvince(firstProv);
      setCity(res.data.data[firstProv][0].city);
    }).catch(() => {});
  }, []);

  // 获取选中日期的农历
  useEffect(() => {
    axios.get(`/api/lunar?year=${selYear}&month=${selMonth}&day=${selDay}`)
      .then(res => setLunarInfo(res.data.data))
      .catch(() => setLunarInfo(null));
  }, [selYear, selMonth, selDay]);

  const cells = buildCalendar(calYear, calMonth);

  function prevMonth() {
    if (calMonth === 1) { setCalYear(y => y - 1); setCalMonth(12); }
    else setCalMonth(m => m - 1);
  }
  function nextMonth() {
    if (calMonth === 12) { setCalYear(y => y + 1); setCalMonth(1); }
    else setCalMonth(m => m + 1);
  }

  function selectDay(d) {
    setSelYear(calYear);
    setSelMonth(calMonth);
    setSelDay(d);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post('/api/paipan', {
        year: selYear, month: selMonth, day: selDay,
        hour, minute, gender, name,
        useSolarTime: useSolarTime,
        province, city,
      });
      setResult(res.data.data);
    } catch (err) {
      alert('排盘失败：' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  }

  const isSelected = (d) => d && d === selDay && calYear === selYear && calMonth === selMonth;
  const isToday = (d) => d && d === today.getDate() && calYear === today.getFullYear() && calMonth === (today.getMonth()+1);

  const cityList = province && provinces[province] ? provinces[province] : [];

  const lunarStr = lunarInfo
    ? `农历${lunarInfo.isLeap ? '闰' : ''}${lunarInfo.lunarMonth}月${lunarInfo.lunarDay}日`
    : '';
  const inputFormClass = window.document.body.clientWidth <= 600 ? 'input-form-phone' : 'input-form';
  return (
    <form className={inputFormClass} onSubmit={handleSubmit}>
      {/* 万年历 */}
      <div className="calendar-panel panel">
        <div className="calendar-nav">
          <button type="button" className="nav-btn" onClick={prevMonth}>‹</button>
          <div className="cal-title">
            <select value={calYear} onChange={e => setCalYear(Number(e.target.value))} className="year-sel">
              {Array.from({length: 200}, (_,i) => 1920+i).map(y =>
                <option key={y} value={y}>{y}年</option>)}
            </select>
            <select value={calMonth} onChange={e => setCalMonth(Number(e.target.value))} className="month-sel">
              {MONTHS.map((m,i) => <option key={i+1} value={i+1}>{m}</option>)}
            </select>
          </div>
          <button type="button" className="nav-btn" onClick={nextMonth}>›</button>
        </div>
        <div className="calendar-grid">
          {WEEKDAYS.map(w => <div key={w} className="weekday">{w}</div>)}
          {cells.map((d, i) => (
            <div
              key={i}
              className={`cal-cell${d ? ' active' : ''}${isSelected(d) ? ' selected' : ''}${isToday(d) ? ' today' : ''}`}
              onClick={() => d && selectDay(d)}
            >
              {d || ''}
            </div>
          ))}
        </div>
        <div className="sel-date-info">
          <span className="solar-date">公历 {selYear}年{selMonth}月{selDay}日</span>
          {lunarStr && <span className="lunar-date">{lunarStr}</span>}
        </div>
      </div>
      <div className="form-layout">
        {/* 参数面板 */}
        <div className="params-panel panel">
          <div className="form-row">
            <label>姓名</label>
            <input
              className="text-input"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="输入姓名"
            />
          </div>
          <div className="form-row">
            <label>性别</label>
            <div className="radio-group">
              <label className={`radio-btn${gender==='男'?' active':''}`}>
                <input type="radio" value="男" checked={gender==='男'} onChange={() => setGender('男')} />
                男
              </label>
              <label className={`radio-btn${gender==='女'?' active':''}`}>
                <input type="radio" value="女" checked={gender==='女'} onChange={() => setGender('女')} />
                女
              </label>
            </div>
          </div>
          <div className="form-row">
            <label>时辰</label>
            <div className="time-group">
              <select className="select-input" value={hour} onChange={e => setHour(Number(e.target.value))}>
                {Array.from({length:24},(_,i) => (
                  <option key={i} value={i}>{String(i).padStart(2,'0')}时</option>
                ))}
              </select>
              <select className="select-input" value={minute} onChange={e => setMinute(Number(e.target.value))}>
                {Array.from({length:60},(_,i) => (
                  <option key={i} value={i}>{String(i).padStart(2,'0')}分</option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-row">
            <label>真太阳时</label>
            <div>
              <input
                type="checkbox"
                checked={useSolarTime}
                onChange={e => setUseSolarTime(e.target.checked)}
              />
            </div>
            {useSolarTime && (
              <div className="location-group">
                <select
                  className="select-input"
                  value={province}
                  onChange={e => {
                    setProvince(e.target.value);
                    const first = provinces[e.target.value]?.[0];
                    if (first) setCity(first.city);
                  }}
                >
                  {Object.keys(provinces).map(p => <option key={p} value={p}>{p}</option>)}
                </select>
                <select
                  className="select-input"
                  value={city}
                  onChange={e => setCity(e.target.value)}
                >
                  {cityList.map(c => <option key={c.city} value={c.city}>{c.city}</option>)}
                </select>
              </div>
            )}
          </div>
          <div className="submit-row">
            <button type="submit" className="submit-btn">
              开始排盘
            </button>
            {/*
            <button type="button" className="submit-btn" onClick={() => setShowShanren(true)}>
              ✦ 请山人
            </button>
            */}
          </div>
          {showShanren && (
            <div className="shanren-overlay" onClick={() => setShowShanren(false)}>
              <div className="shanren-modal" onClick={e => e.stopPropagation()}>
                <img src={require('./shanren.jpg')} alt="山人" className="shanren-img" />
              </div>
            </div>
          )}
          <div className="tips">
            <p>提示1：在日历中点击选择出生日期</p>
            <p>提示2：默认北京时间；勾选真太阳时需选出生地</p>
            <p>提示3：23时前算当日，23时后算次日子时</p>
          </div>
        </div>
      </div>
    </form>
  );
}
